import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr';
import { CurrentUserService } from '../user/current-user.service';

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  private hubConnection: HubConnection | null = null;
  private hubUrl: string = '';
  private baseUrl: string = '';

  constructor(private currentUserService: CurrentUserService) {}

  start(hubUrl: string, baseUrl: string) {
    if (this.hubConnection && this.hubConnection.state === 'Connected') {
      return this.hubConnection;
    }

    this.hubUrl = `${baseUrl}/${hubUrl}`;
    this.baseUrl = baseUrl;

    const currentUser = this.currentUserService.GetSession();
    const builder: HubConnectionBuilder = new HubConnectionBuilder();

    this.hubConnection = builder
      .withUrl(this.hubUrl, {
        accessTokenFactory: () => currentUser.token,
      })
      .withAutomaticReconnect()
      .build();

    this.hubConnection
      .start()
      .then(() => console.log('Successfully connected', this.hubUrl))
      .catch((error: any) =>
        setTimeout(() => this.start(hubUrl, baseUrl), 2000)
      );

    this.hubConnection.onreconnected((connectionId: any) =>
      console.log('Reconnected')
    );
    this.hubConnection.onreconnecting((error: any) =>
      console.log('Reconnecting')
    );
    this.hubConnection.onclose((error: any) =>
      console.log('Close reconnection')
    );

    return this.hubConnection;
  }

  invoke(
    hubUrl: string,
    baseUrl: string,
    procedureName: string,
    message: any,
    successCallBack?: (value: any) => void,
    errorCallBack?: (error: any) => void
  ) {
    this.start(hubUrl, baseUrl)
      .invoke(procedureName, message)
      .then(successCallBack)
      .catch(errorCallBack);
  }

  on(
    hubUrl: string,
    procedureName: string,
    baseUrl: string,
    callBack: (...message: any) => void
  ) {
    this.start(hubUrl, baseUrl).on(procedureName, callBack);
  }
}
